

import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { ServiceData } from "../Services/Service";
import dayjs from "dayjs";

const useAutoAlerteSonore = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [actif, setActif] = useState(() => localStorage.getItem("alerte_son_active") === "true");

  useEffect(() => {
    audioRef.current = new Audio("/alert.mp3");
    audioRef.current.volume = 1;

    // ✅ Autoriser le son sur clic utilisateur
    const autoriserSon = () => {
      setActif(true);
      localStorage.setItem("alerte_son_active", "true");

      // 🧠 Joue/pause pour autoriser le navigateur
      audioRef.current?.play().then(() => {
        audioRef.current?.pause();
        audioRef.current!.currentTime = 0;
        console.log("✅ Son activé par clic utilisateur");
      }).catch(err => {
        console.warn("🔇 Impossible d'activer le son :", err);
      });

      window.removeEventListener("click", autoriserSon);
    };

    if (!actif) {
      window.addEventListener("click", autoriserSon);
    }

    const verifier = async () => {
      try {
        const bordereaux = await ServiceData("/api/admin/listbordereau", "GET");

        if (!Array.isArray(bordereaux)) {
          return;
        }
        
        
        

        // 🔁 Nettoyer les alertes si livraison faite
        bordereaux.forEach((b: any) => {
          if (b.isSend) {
            const alertesMinutes = [120, 60, 30, 0];
            alertesMinutes.forEach((m) => {
              const key = `alerte-sonore-${b.id}-M${m}`;
              localStorage.removeItem(key);
              localStorage.removeItem(`${key}-date`);
            });
          }
        });

        const aujourdHui = dayjs().format("YYYY-MM-DD");

        const nonLivres = bordereaux.filter((b: any) => {
          const rawDate = b.Datelivraison?.date || b.Datelivraison;
          const dateLivraison = dayjs(rawDate);
          return dateLivraison.isValid() && !b.isSend && dateLivraison.format("YYYY-MM-DD") === aujourdHui;
        });
        

        nonLivres.forEach((b: any) => {
          const rawDate = b.Datelivraison?.date || b.Datelivraison;
          const dateLivraison = dayjs(rawDate);

          if (!dateLivraison.isValid()) {
            // console.warn("❌ Date invalide pour le bordereau", b.id, rawDate);
            return;
          }

          const alertes = [
            { label: "dans 2h", minutesAvant: 120 },
            { label: "dans 1h", minutesAvant: 60 },
            { label: "dans 30 min", minutesAvant: 30 },
            { label: "maintenant", minutesAvant: 0 }
          ];

          alertes.forEach(({ label, minutesAvant }) => {
            const dateAlerte = dateLivraison.subtract(minutesAvant, "minute");
            const diffSec = dateAlerte.diff(dayjs(), "second");
            const key = `alerte-sonore-${b.id}-M${minutesAvant}`;
            const savedDate = localStorage.getItem(`${key}-date`);
            const dejaEnvoye = localStorage.getItem(key);

            if (savedDate && savedDate !== dateLivraison.toISOString()) {
              localStorage.removeItem(key);
              localStorage.removeItem(`${key}-date`);
            }

            // console.log("🧪 Vérification alerte:", {
            //   bordereau: b.id,
            //   heureLivraison: dateLivraison.format("HH:mm:ss"),
            //   maintenant: dayjs().format("HH:mm:ss"),
            //   label,
            //   diffSec,
            //   dejaEnvoye,
            // });

            if (!dejaEnvoye && diffSec >= 0 && diffSec < 60) {
              // ✅ Son joué uniquement si actif
              if (actif) {
                audioRef.current?.play().then(() => {
                  console.log("✅ Son joué !");
                }).catch((err) => {
                  console.warn("🔇 Échec du son :", err);
                });
              }

              const msg = `Livraison ${label} :  ${b.Destinataire } prévu livré à ${dateLivraison.format("HH:mm:ss")}`;
              toast.warn(msg, {
                autoClose: false,
                closeOnClick: false,
                closeButton: true,
                pauseOnHover: true,
                draggable: true,
              });

              localStorage.setItem(key, "envoye");
              localStorage.setItem(`${key}-date`, dateLivraison.toISOString());
            }
          });
        });
      } catch (err) {
        console.error("❌ Erreur lors de la vérification :", err);
      }
    };

    verifier();
    const interval = setInterval(verifier, 30000);
    return () => {
      clearInterval(interval);
      window.removeEventListener("click", autoriserSon);
    };
  }, [actif]);
};

export default useAutoAlerteSonore;

